import { render, staticRenderFns } from "./EditCustomerUserName1.vue?vue&type=template&id=56899094&"
import script from "./EditCustomerUserName1.vue?vue&type=script&lang=js&"
export * from "./EditCustomerUserName1.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports